import { render, staticRenderFns } from "./ISAAlertListNotificationHelp.vue?vue&type=template&id=41085e24&scoped=true&"
import script from "./ISAAlertListNotificationHelp.vue?vue&type=script&lang=js&"
export * from "./ISAAlertListNotificationHelp.vue?vue&type=script&lang=js&"
import style0 from "./ISAAlertListNotificationHelp.vue?vue&type=style&index=0&id=41085e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41085e24",
  null
  
)

export default component.exports